import React, { useEffect } from "react";
import { EButton, EPageTitle, ETable } from "../../libs/ui";
import PageLayout from "../../PageLayout";
import { DatePicker } from "@mantine/dates";
import useMasterData from "../Hooks/useMasterData";
import useDailyStudentAttendance from "./hook/useDailyStudentAttendance";
import { ROLES } from "../../Routes/routes";
import { Select, Skeleton, Text, TextInput } from "@mantine/core";
import { MdSearch } from "react-icons/md";
import AttendanceStatCard from "../TeacherTrainingAttendance/components/AttendanceStatCard";
import {
  HiCheckCircle,
  HiClipboardCheck,
  HiUserGroup,
  HiXCircle,
} from "react-icons/hi";
import { ECard } from "../../libs/ui/src/Card/ECard";
import moment from "moment";

const DailyStudentAttendance = () => {
  const {
    district,
    setDistrict,
    block,
    setBlock,
    cluster,
    setCluster,
    school,
    setSchool,
    districts,
    blocks,
    classes,
    schools,
    clusters,
    user,
    role,
    status,
    setStatus,
    grade,
    setGrade,
    date,
    setDate,
    loading,
    getAttendanceData,
    data,
    allData,
    search,
    setSearch,
    currentPage,
    setCurrentPage,
    itemsPerPage,
    totalRecords,
    nextPage,
    prevPage,
  }: any = useDailyStudentAttendance();
  console.log("data",data)
  console.log("AllData",allData)

  const totalPages = Math.ceil(totalRecords / itemsPerPage);

  let startPage = Math.max(1, currentPage - Math.floor(itemsPerPage / 2 / 2));
  let endPage = Math.min(totalPages, startPage + itemsPerPage / 2 - 1);

  if (endPage - startPage + 1 < itemsPerPage / 2) {
    if (currentPage <= Math.ceil(itemsPerPage / 2 / 2)) {
      endPage = Math.min(itemsPerPage / 2, totalPages);
    } else if (currentPage > totalPages - Math.floor(itemsPerPage / 2 / 2)) {
      startPage = Math.max(1, totalPages - itemsPerPage / 2 + 1);
    } else {
      startPage = Math.max(1, currentPage - Math.floor(itemsPerPage / 2 / 2));
      endPage = Math.min(
        totalPages,
        currentPage + Math.floor(itemsPerPage / 2 / 2),
      );
    }
  }

  return (
    <div>
      <PageLayout>
        <EPageTitle title="Daily Student Attendance" />
        <div className="filter-container">
          <div className="flex flex-col">
            <div className="flex flex-wrap gap-2 items-end">
              <Select
                clearable
                size="md"
                label="District"
                className="w-1/6 grow"
                disabled={
                  role?.includes(ROLES.BLOCK) ||
                  role?.includes(ROLES.SCHOOL) ||
                  role?.includes(ROLES.DISTRICT)
                    ? true
                    : false
                }
                placeholder="Select"
                value={district ? String(district) : null}
                data={districts?.map((each: any) => ({
                  value: String(each.id),
                  label: each.name,
                }))}
                onChange={(e) => {
                  setDistrict(e ? Number(e) : undefined);
                  setBlock(undefined);
                  setCluster(undefined);
                  setSchool(undefined);
                }}
              />

              <Select
                clearable
                size="md"
                label="Block"
                className="w-1/6 grow"
                placeholder="Select"
                disabled={
                  !district ||
                  role?.includes(ROLES.BLOCK) ||
                  role?.includes(ROLES.SCHOOL)
                    ? true
                    : false
                }
                value={block ? String(block) : null}
                data={blocks?.map((e: any) => {
                  return {
                    value: String(e.id),
                    label: e.name,
                  };
                })}
                onChange={(e) => {
                  setBlock(e ? Number(e) : undefined);
                  setCluster(undefined);
                  setSchool(undefined);
                }}
              />

              <Select
                clearable
                size="md"
                label="Cluster"
                placeholder="Select"
                className="w-1/6 grow "
                disabled={!block || role?.includes(ROLES.SCHOOL) ? true : false}
                value={cluster ? String(cluster) : null}
                data={clusters?.map((e: any) => {
                  return {
                    value: String(e.cluster_School_Id),
                    label: e.cluster_School_Name,
                  };
                })}
                onChange={(e) => {
                  setCluster(e ? Number(e) : undefined);
                  setSchool(undefined);
                }}
              />

              <Select
                clearable
                size="md"
                label="School"
                placeholder="Select"
                className="w-1/6 grow"
                disabled={
                  !cluster || role?.includes(ROLES.SCHOOL) ? true : false
                }
                value={school ? String(school) : null}
                data={schools?.map((e: any) => {
                  return {
                    value: String(e?.school_Code),
                    label: e.school_Name,
                  };
                })}
                onChange={(e) => {
                  setSchool(e ? Number(e) : undefined);
                }}
              />

              <Select
                size="md"
                label="Grade"
                required
                placeholder="Select"
                className=" w-1/6 grow"
                value={
                  grade !== undefined && grade !== null ? String(grade) : null
                }
                data={[
                  { value: "0", label: "All" },
                  ...(classes?.map((e: any) => ({
                    value: String(e?.id),
                    label: e?.name,
                  })) ?? []),
                ]}
                onChange={(e) => {
                  setGrade(e ? Number(e) : undefined);
                }}
              />
              <Select
                clearable
                size="md"
                label="Status"
                placeholder="Select"
                className="w-1/6"
                value={status ? String(status) : null}
                data={[
                  {
                    label: "All",
                    value: "3",
                  },
                  {
                    label: "Present",
                    value: "1",
                  },
                  {
                    label: "Absent",
                    value: "2",
                  },
                  {
                    label: "Pending",
                    value: "0",
                  },
                ]}
                onChange={(e) => {
                  setStatus(e ? String(e) : undefined);
                }}
              />
              <DatePicker
                size="md"
                label="Date"
                placeholder="Pick date"
                className="w-1/6"
                value={date ? new Date(date) : null}
                onChange={(e) => {
                  setDate(e ? e.toISOString() : undefined);
                }}
              />

              <EButton
                size="md"
                className="btn-blue"
                rightIcon={<MdSearch />}
                disabled={
                  !district ||
                  !block ||
                  !cluster ||
                  !school ||
                  grade === undefined ||
                  grade === null ||
                  !date ||
                  !status
                    ? true
                    : false
                }
                onClick={() => getAttendanceData()}
                loading={loading}
              >
                Search
              </EButton>
            </div>
          </div>
        </div>
        <div>
          {/* KPI strip */}
          {allData?.studentDetails?.length > 0 ? (
            <div className="flex gap-4 mt-6 flex-wrap">
              <AttendanceStatCard
                label="Present Students"
                value={allData?.markedPresent ?? "--"}
                icon={HiUserGroup}
                isLoading={loading}
                textClass="text-green-600"
              />
              <AttendanceStatCard
                label="Absent Students"
                value={allData?.markedAbsent ?? "--"}
                icon={HiXCircle}
                isLoading={loading}
                textClass="text-red-600"
              />
              <AttendanceStatCard
                label="Pending Students"
                value={allData?.attendancePending ?? "--"}
                icon={HiClipboardCheck}
                isLoading={loading}
                textClass="text-yellow-600"
              />
            </div>
          ) : null}
          <div className="mt-4">
            <ECard noHeader title="" customClass="overflow-auto">
              {!loading ? (
                <>
                  {allData?.studentDetails?.length > 0 ? (
                    <div className="flex justify-end mb-4">
                      <TextInput
                        size="md"
                        placeholder="Search Student Name"
                        value={search}
                        onChange={(e) => setSearch(e?.target?.value)}
                        className="w-1/3"
                      />
                    </div>
                  ) : null}

                  {data?.length > 0 ? (
                    <>
                      <ETable>
                        <thead>
                          <tr>
                            <th>S No.</th>
                            <th>Student Name</th>
                            <th>Student SRN No.</th>
                            <th>Class</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.map((item: any, index: any) => {
                            return (
                              <tr>
                                <td>
                                  {search
                                    ? index + 1
                                    : currentPage * itemsPerPage + (index + 1)}
                                </td>
                                <td>{item?.student_Name}</td>
                                <td>{item?.student_SRN_No}</td>
                                <td>Class {item?.class_Id}</td>
                                <td>{item?.attendance_Status}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </ETable>

                      <div className="text-end mt-2">
                        {/* Pagination controls */}
                        <EButton
                          className="btn-blue"
                          onClick={prevPage}
                          disabled={currentPage === 0}
                        >
                          Previous
                        </EButton>

                        {/* Render first page */}
                        {startPage > 1 && (
                          <>
                            <EButton
                              onClick={() => setCurrentPage(0)}
                              className="btn-light ml-2"
                            >
                              1
                            </EButton>
                            {startPage > 2 && <span className="ml-2">...</span>}
                          </>
                        )}

                        {/* Render page numbers */}
                        {Array.from(
                          { length: endPage - startPage + 1 },
                          (_, index) => startPage + index,
                        ).map((page) => (
                          <EButton
                            key={page}
                            onClick={() => setCurrentPage(page - 1)}
                            className={
                              currentPage === page - 1
                                ? "btn-blue ml-2"
                                : "btn-light ml-2"
                            }
                          >
                            {page}
                          </EButton>
                        ))}

                        {/* Render last page */}
                        {endPage < totalPages && (
                          <>
                            {endPage < totalPages - 1 && (
                              <span className="ml-2">...</span>
                            )}
                            <EButton
                              onClick={() => setCurrentPage(totalPages - 1)}
                              className={
                                currentPage === totalPages - 1
                                  ? "btn-blue ml-2"
                                  : "btn-light ml-2"
                              }
                            >
                              {totalPages}
                            </EButton>
                          </>
                        )}

                        <EButton
                          className="btn-blue ml-2"
                          onClick={nextPage}
                          disabled={
                            data?.length < itemsPerPage ||
                            currentPage === totalPages - 1
                          }
                        >
                          Next
                        </EButton>
                      </div>
                    </>
                  ) : (
                    <div className="text-blue-600 text-sm mt-2 mb-2 text-center">
                      <Text fz="md">No record Found!</Text>
                    </div>
                  )}
                </>
              ) : (
                <Skeleton height={220} radius="md" />
              )}
            </ECard>
          </div>
        </div>
      </PageLayout>
    </div>
  );
};

export default DailyStudentAttendance;
